exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cus-dialog.is-fullscreen > .el-dialog__body {\n  height: calc(100% - 66px);\n}\n.cus-dialog-detail.is-fullscreen > .el-dialog__body {\n  height: calc(100% - 74px);\n}\n.cus-dialog > .el-dialog__body,\n.cus-dialog-detail > .el-dialog__body {\n  padding: 20px;\n  padding-top: 0px;\n}\n.cus-dialog > .el-dialog__header,\n.cus-dialog-detail > .el-dialog__header {\n  display: flex;\n  align-items: center;\n}\n\n", ""]);

// exports
